// extracted by mini-css-extract-plugin
export var content = "_n8-1";
export var noScroll = "_n8-3";
export var paper = "_n8-0";
export var scrollable = "_n8-2";